import { render, staticRenderFns } from "./CategorySwitch.vue?vue&type=template&id=5942c5f5&scoped=true&"
import script from "./CategorySwitch.vue?vue&type=script&lang=js&"
export * from "./CategorySwitch.vue?vue&type=script&lang=js&"
import style0 from "./CategorySwitch.vue?vue&type=style&index=0&id=5942c5f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942c5f5",
  null
  
)

export default component.exports